import ServiceTemplate from '@/components/ServiceTemplate';

export default function PartnershipLLP() {
  const data = {
    title: 'Partnership and LLP Formation',
    subtitle: 'Professional partnership and Limited Liability Partnership formation services.',
    overviewTitle: 'Understanding Partnerships and LLPs',
    overviewImage: 'https://images.unsplash.com/photo-1751170359998-36c22ed75d33',
    description: [
      'Partnerships and Limited Liability Partnerships (LLPs) are business structures for multiple owners. LLPs provide personal liability protection while maintaining partnership tax treatment and flexibility.',
      'We assist in forming general partnerships, limited partnerships, and LLPs, preparing partnership agreements that clearly define roles, responsibilities, and profit sharing among partners.',
      'Our service ensures your partnership is properly structured with comprehensive agreements that prevent disputes and provide clear guidelines for partnership management.'
    ],
    benefits: [
      { title: 'Flexible Management', description: 'Partners share management and decision-making.' },
      { title: 'Pass-Through Taxation', description: 'Avoid double taxation with flow-through income.' },
      { title: 'Liability Protection', description: 'LLPs provide personal liability protection.' },
      { title: 'Simple Formation', description: 'Less complex than corporate structures.' },
      { title: 'Professional Structure', description: 'Ideal for professional service firms.' },
      { title: 'Clear Agreements', description: 'Comprehensive partnership agreements prevent disputes.' }
    ],
    process: [
      { title: 'Investigation & Analysis', description: 'Comprehensive review and analysis of all relevant legal, financial, and operational factors.' },
      { title: 'Documentation & Recommendations', description: 'Detailed documentation of findings with strategic recommendations for action.' },
      { title: 'Implementation & Support', description: 'Ongoing support for implementation of recommendations and resolution of issues.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential formation',
        price: '$299',
        period: '+ state fees',
        features: [
          'Entity formation filing',
          'Name availability check',
          'EIN application',
          'Basic documents',
          'Email support',
          'Document delivery'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete package',
        price: '$599',
        period: '+ state fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Custom agreements',
          'Tax consultation',
          'Compliance setup',
          'Registered agent (1 year)',
          'Priority processing',
          'Phone support'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Full-service solution',
        price: '$999',
        period: '+ state fees',
        features: [
          'Everything in Professional',
          'Multi-state filing',
          'Advanced structuring',
          'Annual compliance',
          'Quarterly reviews',
          'Dedicated attorney',
          'Unlimited consultations'
        ]
      }
    ],
    faqs: [
      { question: 'What is the difference between partnership types?', answer: 'General partnerships share all liability equally; limited partnerships have general and limited partners; LLPs provide liability protection to all partners.' },
      { question: 'Do I need a written partnership agreement?', answer: 'While not always legally required, a comprehensive written agreement is essential to prevent disputes and clarify partner rights and responsibilities.' },
      { question: 'How are partnerships taxed?', answer: 'Partnerships have pass-through taxation where income flows to partners\' personal returns, avoiding entity-level taxation.' },
      { question: 'What is a limited partner?', answer: 'Limited partners are investors with limited liability and limited management participation, typically used in limited partnerships.' },
      { question: 'Can professionals form LLPs?', answer: 'Yes, LLPs are popular for professional service firms including attorneys, accountants, architects, and consultants.' },
      { question: 'How do partners get paid?', answer: 'Partners typically receive distributions based on their partnership percentage, plus potentially guaranteed payments for services.' },
      { question: 'What happens when a partner leaves?', answer: 'The partnership agreement should address buyout terms, valuation methods, and procedures for partner departure or death.' },
      { question: 'Do LLPs provide full liability protection?', answer: 'LLPs protect partners from liability for other partners\' negligence but not from their own professional malpractice.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
